import axios from 'axios';

import { POST_PAYMENT_URL } from '../constants/constants';

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json;charset=utf-8',
});

export const postPayment = (token, data) => {
  return axios.post(POST_PAYMENT_URL, data, { headers: headers(token) });
};
